import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useMatomoTracker from '../hooks/useMatomoTracker';

const RouteTracker = () => {
  useMatomoTracker();
  return null;
};

export default RouteTracker;